import { CheckCircle, CheckCircleOutlineOutlined } from '@mui/icons-material'
import { Tooltip, ToggleButton } from '@mui/material'
import { useIntlMessages } from 'app/localization/useIntlMessages'

const messageIds = {
  markAsResolved: 'collaboration.comments.actions.markAsResolved',
  reopen: 'collaboration.comments.actions.reopen'
}

export default function ResolveButton({
  resolved,
  onClick
}: {
  resolved?: boolean
  onClick: (event: React.MouseEvent) => void
}) {
  const messages = useIntlMessages(messageIds)
  const label = resolved ? messages.reopen : messages.markAsResolved
  return (
    <Tooltip title={label}>
      <ToggleButton value="resolved" selected={resolved} onClick={onClick} aria-label={label}>
        {resolved ? <CheckCircle /> : <CheckCircleOutlineOutlined />}
      </ToggleButton>
    </Tooltip>
  )
}
